/**
 * AddLiveRewindCtrl controller
 * Add/Edit live Rewind
 */

import {
  DRM_ACCOUNT_TYPES,
  LIVE_REWIND_OPTIONS,
  STREAMING_PROVIDER_TYPES,
  URL_PATTERN_FOR_TEMPLATES
} from 'app/core/constants'
import { TypeaheadClass } from '../../app/helpers/typeahead'

/**
 * AddLiveRewindCtrl controller
 *
 * @class AddLiveRewindCtrl
 * @memberof mwApp/service
 * @see mwApp/service
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/addLiveRewind.controller:AddLiveRewindCtrl
 */
/* @ngInject */
export default function AddLiveRewindCtrl (
  $scope,
  $uibModalInstance,
  LiveRewind,
  LiveRewindChannel,
  TemplateVariable,
  authSvc,
  chnl,
  lrw
) {
  var vm = this
  const Lrw = chnl ? LiveRewindChannel : LiveRewind

  vm.urlPattern = URL_PATTERN_FOR_TEMPLATES

  /**
   * Auth service
   *
   * @memberof mwApp/addLiveRewind.controller:AddLiveRewindCtrl
   * @type {Object}
   */
  vm.authSvc = authSvc

  /**
   * DRM profiles
   *
   * @memberOf mwApp/addLiveRewind.controller:AddLiveRewindCtrl
   * @type {String[]}
   */
  vm.drmProfiles = []

  /**
   * DRM account types
   *
   * @memberOf mwApp/addLiveRewind.controller:AddLiveRewindCtrl
   * @type {Object}
   */
  vm.drm_account_types = DRM_ACCOUNT_TYPES

  /**
   * Live Rewind Options
   *
   * @memberOf mwApp/addLiveRewind.controller:AddLiveRewindCtrl
   * @type {Object}
   */
  vm.live_rewind_options = LIVE_REWIND_OPTIONS
  vm.liveRewindOptions = Object.keys(LIVE_REWIND_OPTIONS)

  /**
   * Live Rewind
   *
   * @memberof mwApp/addLiveRewind.controller:AddLiveRewindCtrl
   * @type {models.LiveRewind}
   */
  vm.lrw = lrw

  /**
   * Channel
   *
   * @memberof mwApp/addLiveRewind.controller:AddLiveRewindCtrl
   * @type {models.Channel|null}
   */
  vm.chnl = chnl

  /**
   * Streaming Provider types
   *
   * @memberof mwApp/addLiveRewind.controller:AddLiveRewindCtrl
   * @type {object}
   */
  vm.streaming_provider_types = angular.copy(STREAMING_PROVIDER_TYPES)
  delete vm.streaming_provider_types.WOWZA
  delete vm.streaming_provider_types.AKAMAI_V2
  delete vm.streaming_provider_types.AKAMAI

  /**
   * isNew flag
   *
   * @memberof mwApp/addLiveRewind.controller:AddLiveRewindCtrl
   * @type {Boolean}
   */
  vm.isNew = lrw._isNew()

  var channels = vm.channels = []

  /**
   * Set default channel
   */
  if (chnl) {
    vm.lrw.channel = chnl
  }

  // load channels and catchup nodes from extra
  Lrw.loadExtra(Lrw.extraFor(lrw))
    .then(extra => {
      channels = extra.channels
      vm.drmProfiles = extra.drmProfiles
        .map(({ id, name, enabled, providerType, drmType }) => ({ id, name, enabled, providerType, drmType }))
      vm.playbackTokenGenerators = extra.playbackTokenGenerators
    })

  /**
   * Filter channels, it seems that this works faster, then filter in ui-select-choices
   *
   * @param  {String} search
   */
  vm.refreshChannels = function (search) {
    search = search ? search.toLowerCase() : null

    vm.channels = search
      ? channels.filter(c => c.name && c.name.toLowerCase().indexOf(search) >= 0)
      : null
  }

  /**
   * Create or edit catchup, and close modal window afterwards
   *
   * @memberof mwApp/addLiveRewind.controller:AddLiveRewindCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    lrw._save()
      .then(
        () => {
          // reload after create/update
          lrw._update()
            .finally(
              () => {
                $uibModalInstance.close(lrw)
                vm.unsetDisable()
              }
            )
        }
      ).finally(vm.unsetDisable)
  }

  /**
   * Change drm profile callback function
   * @returns {Function}
   */
  vm.changeDrmProfile = () => {
    if (!vm.lrw.mediaUrl.drmProfiles.length) {
      vm.lrw.mediaUrl.kek = null
    }
  }

  /**
   * Disable not enable items
   * @param item
   * @returns {boolean}
   */
  vm.disableChoice = (item) => {
    return !item.enabled
  }

  /**
   * Filter for drm profiles
   * @returns {Function}
   */
  vm.filterProfiles = function () {
    return function (profile) {
      if (!vm.lrw.mediaUrl ||
        !vm.lrw.mediaUrl.drmProfiles ||
        !vm.lrw.mediaUrl.drmProfiles.length) {
        return true
      }

      const selectedProviderType = vm.findSelectedProviderType()
      return profile.providerType === selectedProviderType && !vm.lrw.mediaUrl.drmProfiles.find((p) => p.drmType === profile.drmType)
    }
  }

  /**
   * Find provider type by platformName from selected profiles
   * @returns {Function}
   */
  vm.findSelectedProviderType = () => {
    const selectedProfile = vm.lrw.mediaUrl && vm.lrw.mediaUrl.drmProfiles && vm.lrw.mediaUrl.drmProfiles.length && vm.lrw.mediaUrl.drmProfiles[0]
    if (!selectedProfile) {
      return true
    }

    return selectedProfile.providerType
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/addLiveRewind.controller:AddLiveRewindCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }

  TemplateVariable.loadAllVariables()
    .to(vm.templateVariables = [])
    .then(() => {
      const setUrlValue = function (val) {
        vm.lrw.mediaUrl.mediaUrl = val
      }

      vm.typeaheadUrl = new TypeaheadClass(vm.templateVariables, setUrlValue)
    })

  $scope.$watch('vm.lrw.$storageDuration', () => {
    vm.minErrorMessage = vm.lrw.$storageDuration && (vm.lrw.$storageDuration < 12) ? vm.lrw.$storageDuration : 12
    vm.maxErrorMessage = vm.lrw.$storageDuration && (vm.lrw.$storageDuration < 12) ? 'Value can’t be bigger than Storage Duration' : 'Value must be between 1 and 12'
  })
}
